import api from './api';

/**
 * Create checkout session for Pro subscription/payment
 * Returns different data based on payment gateway:
 * - Stripe: { type: 'redirect', checkoutUrl, sessionId }
 * - Razorpay: { type: 'modal', orderId, keyId, amount, currency, prefill, ... }
 */
export const createCheckoutSession = async () => {
  const response = await api.post('/payments/create-checkout');
  return response.data;
};

/**
 * Verify Razorpay payment after modal checkout
 */
export const verifyRazorpayPayment = async (paymentData) => {
  const response = await api.post('/payments/verify-payment', paymentData);
  return response.data;
};

/**
 * Get current subscription status
 */
export const getSubscription = async () => {
  const response = await api.get('/payments/subscription');
  return response.data;
};

/**
 * Create portal session for managing subscription (Stripe only)
 */
export const createPortalSession = async () => {
  const response = await api.post('/payments/portal');
  return response.data;
};

/**
 * Get available payment gateways
 */
export const getAvailableGateways = async () => {
  const response = await api.get('/payments/gateways');
  return response.data;
};

/**
 * Get recommended payment gateway based on user location
 * Returns: { gateway, currency, price, priceDisplay, period, features, countryCode }
 */
export const getRecommendedGateway = async () => {
  const response = await api.get('/payments/recommended');
  return response.data;
};

export default {
  createCheckoutSession,
  verifyRazorpayPayment,
  getSubscription,
  createPortalSession,
  getAvailableGateways,
  getRecommendedGateway
};
